import {Client} from '../../../graphql/types'

const AFFILIATE_ID = 36376

export const overrideFor36376 = (accounts: any[], client: Client) => {
  if (client.affiliateId !== AFFILIATE_ID) return accounts

  return accounts.filter(account => !['black', 'raw'].includes(account.accountSubtype))
}
